module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3KnkEkYegMiKYmOu8I4seu-ec3f6756e92a763ee6fe737dd316f649.jpg";